import React, { useState, useEffect } from "react";

function Thumbnail({ thumbnail }) {
  if (!thumbnail) {
    return null;
  }

  if (typeof thumbnail !== "string") {
    return <InMemoryThumbnail file={thumbnail} />;
  }

  return <FilesystemThumbnail src={thumbnail} />;
}

function InMemoryThumbnail({ file }) {
  let [image, setImage] = useState(null);
  useEffect(() => {
    let reader = new FileReader();

    reader.onloadend = () => {
      setImage(
        (
          <img
            src={reader.result as any}
            alt={(file && file.name) || ""}
            className="img-thumbnail mt-2"
            height={200}
            width={200}
          />
        ) as any
      );
    };

    reader.readAsDataURL(file);
  }, [file]);

  return image;
}

function FilesystemThumbnail({ src }) {
  return (
    <img
      src={src}
      alt={src}
      className="img-thumbnail mt-2"
      height={200}
      width={200}
    />
  );
}

export default Thumbnail;
